module.exports = __webpack_public_path__ + "static/media/ic_error-red.5ccc84ca.svg";